import { createContext, RefObject } from 'react';

export interface MenuOption {
  ref: RefObject<HTMLAnchorElement | HTMLDivElement | null>;
  disabled: boolean;
  focused: boolean;
}

export const MenuContext = createContext<Map<string, MenuOption>>(new Map());
